import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  select(event) {
    const index = parseInt(event.currentTarget.dataset.index)
    this.showTab(index)
  }

  showTab(index) {
    // Update tab buttons
    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.remove("border-transparent", "text-gray-500")
        tab.classList.add("text-gray-900", "bg-white")
      } else {
        tab.classList.remove("text-gray-900", "bg-white")
        tab.classList.add("border-transparent", "text-gray-500")
      }
    })

    // Update panels
    this.panelTargets.forEach((panel, i) => {
      if (i === index) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }

  copyActive(event) {
    // Find the currently visible panel
    const activePanel = this.panelTargets.find(panel => !panel.classList.contains('hidden'))
    if (activePanel) {
      const codeElement = activePanel.querySelector('code')
      if (codeElement) {
        const text = codeElement.textContent
        navigator.clipboard.writeText(text).then(() => {
          this.showToast()

          const button = event.currentTarget
          const originalClass = button.className
          button.classList.add('text-green-600')
          setTimeout(() => {
            button.className = originalClass
          }, 2000)
        })
      }
    }
  }

  showToast() {
    const toast = document.createElement('div')
    toast.className = 'fixed bottom-4 right-4 bg-gray-900 text-white px-4 py-3 rounded-lg shadow-lg flex items-center space-x-2 z-50 animate-fade-in'
    toast.innerHTML = `
      <svg class="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
      </svg>
      <span>Copied to clipboard</span>
    `
    document.body.appendChild(toast)

    setTimeout(() => {
      toast.classList.add('animate-fade-out')
      setTimeout(() => toast.remove(), 300)
    }, 2000)
  }
}
